import { Link } from 'react-router-dom';

import { styled } from '@mui/material';

const StyledLink = styled(Link)(({ theme }) => ({
	color: theme.palette.link.main
}));

export default StyledLink;
